module.exports = __webpack_public_path__ + "static/media/_MG_9232.ef46a8b4.jpg";